import React, { Fragment, useEffect, useState } from 'react';
import './index.scss';
import { useDispatch } from 'react-redux';
import { CustomerClaimsTypes, addCliamsByCustomer, companiesForCustomer } from '../../../api/redux/slices/Customer';
import { ButtonComponent } from '../../../components/buttons';
import { showToast } from '../../../components/modal';

const ComplainModal = ({ modalOpen, setModalOpen }) => {
	const [selectSubject, setSelectSubject] = useState('');
	const [selectCompany, setSelectCompany] = useState('');
	const [listClaims, setListClaims] = useState([]);
	const [listCompanies, setListCompanies] = useState([]);
	const [message, setMessage] = useState('');
	const [isLoading, setIsloading] = useState(false);
	const [isLoadingCompanies, setIsLoadingCompanies] = useState(false);

	const token = localStorage.getItem('accesstoken');
	const dispatch = useDispatch();

	// Fetch claim types
	useEffect(() => {
		dispatch(
			CustomerClaimsTypes({
				token,
			}),
		)
			.unwrap()
			.then((res) => setListClaims(res.data))
			.catch((err) => {
				return;
			});
	}, [dispatch, token]);

	// Fetch companies for customer
	useEffect(() => {
		if (modalOpen) {
			setIsLoadingCompanies(true);
			dispatch(companiesForCustomer({ token }))
				.unwrap()
				.then((res) => {
					setListCompanies(res.data || []);
				})
				.catch((err) => {
					console.error('Error fetching companies:', err);
				})
				.finally(() => setIsLoadingCompanies(false));
		}
	}, [dispatch, token, modalOpen]);

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!selectSubject || !selectCompany || !message.trim()) {
			showToast('Veuillez remplir tous les champs', 'warn');
			return;
		}

		setIsloading(true);
		dispatch(
			addCliamsByCustomer({
				token,
				data: {
					object: selectSubject,
					company: selectCompany,
					message: message.trim(),
				},
			}),
		)
			.unwrap()
			.then(() => {
				showToast('Réclamation envoyée avec succès', 'success');
				setModalOpen(false);
				setSelectSubject('');
				setSelectCompany('');
				setMessage('');
			})
			.catch((err) => {
				showToast(err?.message || 'Erreur lors de l\'envoi', 'error');
			})
			.finally(() => {
				setIsloading(false);
			});
	};

	return (
		<div className={'modalcontainer ' + (modalOpen && 'open')}>
			<div className={'modal ' + (modalOpen && 'active')}>
				<h1>Envoyez une réclamation</h1>
				<form onSubmit={handleSubmit}>
					<div className='box'>
						<label>Sujet</label>
						<div className='infodropdown'>
							<select value={selectSubject} onChange={(e) => setSelectSubject(e.target.value)}>
								<option value=''>Liste des sujets</option>
								{listClaims?.map((item) => (
									<Fragment key={item._id}>
										<option value={item._id}>{item.name}</option>
									</Fragment>
								))}
							</select>
						</div>
					</div>
					<div className='box'>
						<label>Société concernée</label>
						<div className='infodropdown'>
							<select value={selectCompany} onChange={(e) => setSelectCompany(e.target.value)}>
								<option value=''>Sélectionnez une société</option>
								{isLoadingCompanies ? (
									<option disabled>Chargement...</option>
								) : (
									listCompanies?.map((company) => (
										<Fragment key={company._id}>
											<option value={company._id}>{company.name}</option>
										</Fragment>
									))
								)}
							</select>
						</div>
					</div>
					<div className='desc-modal'>
						<label>Message</label>
						<textarea
							value={message}
							onChange={(e) => setMessage(e.target.value)}
							cols='3'
							rows='3'
							placeholder='Décrivez votre réclamation...'
						/>
					</div>
					<div className='modalbtn'>
						<button
							className='button-nature-inactive'
							onClick={(e) => {
								e.preventDefault();
								setModalOpen(false);
								setSelectSubject('');
								setSelectCompany('');
								setMessage('');
							}}
						>
							Annuler
						</button>
						<ButtonComponent
							loading={isLoading}
							className={'button-primary'}
							name={'Envoyer'}
							type={'submit'}
						/>
					</div>
				</form>
			</div>
		</div>
	);
};

export default ComplainModal;